import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hey there! I'm <span className="purple">Mohit Bokade</span> from <span className="purple">Nagpur, India.</span>
            <br />
            A passionate <b className="purple">Data Analyst</b> currently working at MasterSoft ERP Solutions Pvt. Ltd., where I  develop machine learning models and build intelligent systems.
            <br />
            I specialize in <b className="purple">Bachelor of Electronic and Telecommunication Engineering</b> from Priyadurshini College of Engineering, Nagpur🚀
            <br />
            <br />
            When I'm not analyzing data or training models, you can find me:
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Exploring new technologies and enhancing my skills in <b className="purple">data science and machine learning.</b>
            </li>
            <li className="about-activity">
              <ImPointRight /> Building and deploying web applications to showcase <b className="purple">data-driven insights.</b>
            </li>
            
            <li className="about-activity">
              <ImPointRight /> Brainstorming innovative solutions to optimize educational processes.
            </li>
            <li className="about-activity">
              <ImPointRight /> Enjoying a cup of coffee while <b className="purple">analyzing data trends!</b>
            </li>
          </ul>
        </blockquote>
      </Card.Body>
    </Card>

  );
}

export default AboutCard;
